import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwitchToAnotherWorkspaceComponent } from './switch-to-another-workspace.component';
import { SharedModule } from 'src/app/shared/shared.module';



@NgModule({
  declarations: [
    SwitchToAnotherWorkspaceComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class SwitchToAnotherWorkspaceModule { }
